/**
 * Created by PuTi(编程即菩提) 2/26/17.
 */
module.exports = function (nb) {
    var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
    var util = {
        isBrowser: isBrowser
    };
    nb.util = util;
};


//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/core/util.js
// module id = 213
// module chunks = 35